export default __webpack_public_path__ + "static/media/box-background-color-hh2.f43422bb.png";